import React, { Component } from 'react';
/* CSS */
import '../../../../Assets/EnsembleStyles/EnsHome.css';

/* Components */
import NavigationBar from '../../../EnsembleComponents/Common/Layouts/NavigationBar/Navigationbar';                                    /* Navigation Bar */


import ViewtenantTab from '../../../EnsembleComponents/TenantComponents/ManageTenants/Tenants/ViewTenant/ViewTenantTabSystem'

/* Side Bar */

/* Footer */
import Footer from '../../../EnsembleComponents/Common/Layouts/Footer/EnsembleFooter';
import Idle from 'react-idle';
import InactiveWindow from '../../../Logout/InActive';
import { Modal } from 'reactstrap';
import { connect } from 'react-redux';



class NewRequest extends Component {
    showSettings(event) {
        event.preventDefault();
    }

    componentDidMount(){
        let StateVal = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
        this.setState({OnPremisesState:StateVal});
        var E_LogoffTime = localStorage.getItem("AutoLogoffTime");
        if (E_LogoffTime !== undefined && E_LogoffTime !== null && E_LogoffTime !== "") {
            this.setState({ LogOffTime : Number(E_LogoffTime) });
        }
    }

    componentWillReceiveProps(nextProps){
        if (this.props !== nextProps) {
            let StateVal = (nextProps.OnPremises !== undefined && nextProps.OnPremises !== null) ? nextProps.OnPremises : false;
            this.setState({OnPremisesState:StateVal});
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            sideSize: 300,
            drag: 300,
            inactive_modal: false,
            OnPremisesState : false,
            LogOffTime: 1200000
        }
        this.toggleSide = this.toggleSide.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
        this.Inactivetoggle = this.Inactivetoggle.bind(this);

    }

    toggleSide(action) {
        switch (action) {
            case "open": this.setState({ sideSize: 200, drag: 200 });
                break;
            case "close": this.setState({ sideSize: 1, drag: 1 });
                break;
            default : break;
        }

    }

    Inactivetoggle() {
        this.setState({
            inactive_modal: !this.state.inactive_modal
        });
    }

    handleDrag(width) {
        this.setState({ drag: width + 10 });
    }

    Extend_Session = (someArg) => {
        this.setState({
            inactive_modal: false
        });
    }

    render(IsOnPremises) {
        
        return (
            <div className="Ensemble">
                <Idle timeout={this.state.LogOffTime} onChange={({ idle }) => {
                    if (idle) {
                        this.setState({ inactive_modal: true });
                    }
                }} />
                {/* Navigation Bar & Title Bar */}
                {
                    !this.state.OnPremisesState ? <div><NavigationBar /> 
                        <div className="Ensemble_Content" style={{height: "100vh"}}>
                            <ViewtenantTab />
                        </div>
                        </div> : <div className="Ensemble_Content"><ViewtenantTab /></div>
                }
                <Modal isOpen={this.state.inactive_modal} inactive_modal={this.inactive_modal} className={"ModalContainer InActive_Short_Modal"} >
                    <InactiveWindow Extend_Session={this.Extend_Session} />
                </Modal>
                {
                    !this.state.OnPremisesState ? <Footer /> : ""
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        OnPremises: state.authService.IsOnPremise
    };
};

export default connect(mapStateToProps, null)(NewRequest);
